import { createContext, useContext, useState, useCallback } from "react";

const QuoteContext = createContext(null);

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used inside QuoteProvider");
  return ctx;
};

export const QuoteProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = useCallback((product, category) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.product_id === product.id);
      if (existing) {
        return prev.map((p) =>
          p.product_id === product.id ? { ...p, quantity: p.quantity + 1 } : p
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          category,
          image: product.image,
          quantity: 1,
        },
      ];
    });
    setIsOpen(true);
  }, []);

  const removeItem = useCallback((product_id) => {
    setItems((prev) => prev.filter((p) => p.product_id !== product_id));
  }, []);

  const updateQty = useCallback((product_id, quantity) => {
    if (quantity < 1) return;
    setItems((prev) =>
      prev.map((p) => (p.product_id === product_id ? { ...p, quantity } : p))
    );
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const totalCount = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <QuoteContext.Provider
      value={{ items, isOpen, setIsOpen, addItem, removeItem, updateQty, clear, totalCount }}
    >
      {children}
    </QuoteContext.Provider>
  );
};
